import React from 'react';
import './IdleScreen.css';

function IdleScreen({ onSendPrompt }) {
  const handleCardClick = (prompt) => {
    onSendPrompt(prompt);
  };

  return (
    <div className="idle-screen">
      <div className="idle-content">
        <img src="android-chrome-192x192.png" alt="Logo" className="idle-logo" /> {/* Add your logo here */}
        <div className="option-cards-container">
          {/* The first card is visible on all screen sizes */}
          <div className="option-card" onClick={() => handleCardClick('What can you help me with using the current knowledge package?')}>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" className="icon-md" style={{ color: 'rgb(226, 197, 65)' }}>
              <path fill="currentColor" fillRule="evenodd" d="M12 3C8.415 3 5.5 5.923 5.5 9.538A6.54 6.54 0 0 0 8.425 15h7.15A6.54 6.54 0 0 0 18.5 9.538C18.5 5.923 15.585 3 12 3m2.865 14h-5.73v1h5.73zm-1.133 3h-3.464a2 2 0 0 0 3.464 0m-5.606 0a4.002 4.002 0 0 0 7.748 0 1 1 0 0 0 .991-1v-2.46A8.54 8.54 0 0 0 20.5 9.539C20.5 4.828 16.7 1 12 1S3.5 4.828 3.5 9.538a8.54 8.54 0 0 0 3.635 7.003V19a1 1 0 0 0 .991 1" clipRule="evenodd"></path>
            </svg>
            <div className="option-card-text">What can you help me with using the current knowledge package?</div>
          </div>

          {/* The second card is hidden on very small screens (less than 640px) */}
          <div className="option-card" onClick={() => handleCardClick('Summarize the current knowledge package.')}>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" className="icon-md" style={{ color: 'rgb(203, 139, 208)' }}>
              <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 18V7h16v11a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2"></path>
              <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 10V6a3 3 0 0 1 3-3v0a3 3 0 0 1 3 3v4"></path>
            </svg>
            <div className="option-card-text">Summarize the current knowledge package.</div>
          </div>

          {/* The third card is hidden on small and very small screens (less than 768px) */}
          <div className="option-card hidden md:block" onClick={() => handleCardClick('What are some important key terms in the knowledge package?')}>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" className="icon-md" style={{ color: 'rgb(237, 98, 98)' }}>
              <path fill="currentColor" fillRule="evenodd" d="M3 6a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3zm3-1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1zm1.293 4.293a1 1 0 0 1 1.414 0l2 2a1 1 0 0 1 0 1.414l-2 2a1 1 0 0 1-1.414-1.414L8.586 12l-1.293-1.293a1 1 0 0 1 0-1.414M12 14a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2h-3a1 1 0 0 1-1-1" clipRule="evenodd"></path>
            </svg>
            <div className="option-card-text">What are some important key terms in the knowledge package?</div>
          </div>

          {/* The fourth card is hidden on screens smaller than 1024px */}
          <div className="option-card hidden lg:block" onClick={() => handleCardClick('Give me some example prompt that I can ask you about the knowledge package.')}>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" className="icon-md" style={{ color: 'rgb(203, 139, 208)' }}>
              <path stroke="currentColor" strokeLinecap="round" strokeWidth="2" d="M3 6h7M3 10h4"></path>
              <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13.428 17.572 20.5 10.5a2.828 2.828 0 1 0-4-4l-7.072 7.072a2 2 0 0 0-.547 1.022L8 19l4.406-.881a2 2 0 0 0 1.022-.547"></path>
            </svg>
            <div className="option-card-text">Give me some example prompt that I can ask you about the knowledge package.</div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default IdleScreen;





